
import React from "react";

import UploaderAraEncapsulated from "../Updloader/UploaderAraEncapsulated";

function Upload(props) {
  return (
    <div className="tab-container-white">
      <div className="upload-content-container">
        <div className="upload-ara-column">
          <UploaderAraEncapsulated {...props} fileField="fileUrlsGeneralDocs" storageFolder="Documents/GeneralDocs" inputId="generalDocumentsUploadFiles" uploadTitle="Upload general documents" uploadDescription="Add up to 3 files. Uploads start automatically after selection." />
        </div>
        <div className="upload-ara-column">
          <UploaderAraEncapsulated {...props} fileField="fileUrlsTherapistDoc" storageFolder="Documents/TherapistDocs" inputId="therapistDocumentsUploadFiles" uploadTitle="Upload therapist documents" uploadDescription="Add up to 3 files. Uploads start automatically after selection." />
        </div>
      </div>
    </div>
  );
}

export default Upload;
